/**
 * Archive Filter - Interação dos dropdowns
 *
 * Gerencia a abertura/fechamento dos dropdowns de filtro
 */
document.addEventListener('DOMContentLoaded', () => {
    const dropdowns = document.querySelectorAll('[data-filter-dropdown]');

    if (!dropdowns.length) return;

    // Fecha todos os dropdowns abertos
    const closeAllDropdowns = () => {
        dropdowns.forEach(dropdown => {
            const trigger = dropdown.querySelector('.archive-filter__select-trigger');
            const options = dropdown.querySelector('.archive-filter__select-options');

            if (trigger && options) {
                trigger.setAttribute('aria-expanded', 'false');
                dropdown.classList.remove('is-open');
            }
        });
    };

    // Adiciona evento de clique em cada trigger
    dropdowns.forEach(dropdown => {
        const trigger = dropdown.querySelector('.archive-filter__select-trigger');

        if (trigger) {
            trigger.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();

                const isExpanded = trigger.getAttribute('aria-expanded') === 'true';

                // Fecha todos os outros dropdowns
                closeAllDropdowns();

                // Toggle do dropdown atual
                if (!isExpanded) {
                    trigger.setAttribute('aria-expanded', 'true');
                    dropdown.classList.add('is-open');
                }
            });
        }
    });

    // Fecha dropdowns ao clicar fora
    document.addEventListener('click', (e) => {
        if (!e.target.closest('[data-filter-dropdown]')) {
            closeAllDropdowns();
        }
    });

    // Fecha dropdowns ao pressionar ESC
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
            closeAllDropdowns();
        }
    });

    // Fecha dropdowns ao selecionar uma opção (após um pequeno delay para permitir a navegação)
    const options = document.querySelectorAll('.archive-filter__select-option');
    options.forEach(option => {
        option.addEventListener('click', () => {
            // O clique navega para uma nova URL, então não precisamos fechar manualmente
            // Mas se fosse AJAX, fecharíamos aqui
        });
    });

    // Customização de conteúdo para archive de oportunidade
    if (document.body.classList.contains('post-type-archive-oportunidade')) {
        const searchInput = document.querySelector('.archive-filter__search-input');
        if (searchInput && typeof hl_archive_filter_data !== 'undefined') {
            searchInput.placeholder = hl_archive_filter_data.search_placeholder;
        }

        const firstDropdown = document.querySelector('[data-filter-dropdown]');
        if (firstDropdown && typeof hl_archive_filter_data !== 'undefined') {
            const label = firstDropdown.querySelector('.archive-filter__select-label');
            if (label && !label.textContent.includes(':')) {
                label.textContent = hl_archive_filter_data.opportunity_type;
            }
        }
    }
});